import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=1e8c0bcb&scoped=true&"
import script from "./CheckPage.vue?vue&type=script&lang=js&"
export * from "./CheckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c0bcb",
  null
  
)

export default component.exports